// extracted by mini-css-extract-plugin
export default {"input":"GenerateDialog_input__KvuBZ"};